import API from '@/services/api/api'
import axios from 'axios'

export default async records => {
    try {
        const route = API.ACCOUNTING_BANK_CARD_UPLOAD
        let data = {
            records: records,
        }
        let response = await axios.post(route, data)
        return response
    } catch (error) {
        return error.response.data
    }
}
